<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Bn4tvs/tc-custom/9781497652712.jpg?1726454431517" alt="This image is the cover for the book Money Game"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Money Game
      </h1>
      <p class="bookDescription body article font2">
        <b>“The best book there is about the stock market”—timeless investing basics by the host of the Emmy Award–winning show <i>Adam Smith’s Money World</i> (<i>The New York Times Book Review</i>).</b><br/><br/> This essential book takes readers to the Street to learn about the intricacies of money and how the stock market impacts every area of our lives. According to the author, the key to making wise, lucrative investments is knowing ourselves. In witty, easily accessible language, he shares pithy insights about the role of intuition and the psychology of guilt, arguing that there is no substitute for information. Smith’s Irregular Rules shatter common myths and misconceptions, revealing why nothing works all the time and illustrating how greed and fear fuel the market.<br/>  <br/> Readers will learn about the safest types of investing, the key to following market trends, and how to capitalize growth, gleaning tips on stock movers, winners and losers, and much more. Peppered with entertaining and prescient anecdotes, <i>The Money Game </i>analyzes who makes the really big money and explores the meaning of our desire to become rich. From selling short and buying long to Wall Street’s crowd mentality, from what constitutes a random walk to why timing is everything, this is the definitive portrait of the Street, then and now.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam Smith
      </h2>
      
      <p class="authorDescription body article">Adam Smith (1930&ndash;2014) is the pseudonym of George Goodman, a writer and editor best known for his Emmy Award&ndash;winning PBS program&#160;<I>Adam Smith&rsquo;s Money World</I>. After graduating from Harvard College, he studied political economy as a Rhodes scholar at the University of Oxford. Goodman made his name as a journalist presenting financial and economic concepts to mainstream audiences and was a bestselling author of numerous books, including&#160;<I>The Money Game</I>,&#160;<I>Supermoney</I>, and&#160;<I>Powers of Mind</I>. He was also a screenwriter, as well as a cofounder of&#160;<I>New York&#160;</I>magazine and&#160;<I>Institutional Investor</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6dd786c0